var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 283,
    viewBox: "0 0 283 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4264 113.137C67.6263 87.9372 85.8299 69.7636 101.554 57.7662C117.048 45.9449 128.954 41.066 141.421 41.066C153.889 41.066 165.795 45.9449 181.288 57.7662C197.013 69.7636 215.216 87.9372 240.416 113.137L268.701 141.421L240.416 169.706C215.216 194.906 197.013 213.079 181.288 225.076C165.795 236.898 153.889 241.777 141.421 241.777C128.954 241.777 117.048 236.898 101.554 225.076C85.8299 213.079 67.6263 194.906 42.4264 169.706L14.1421 141.421L42.4264 113.137Z",
    fill: "#DADADA",
    stroke: "#B8B8B8",
    strokeWidth: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 141,
    r: 40,
    fill: "black",
    stroke: "#545454",
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 125.5,
    r: 16.5,
    fill: "white",
    stroke: "#545454",
    strokeWidth: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.bd390c06c1deccc23474b2e36af419fb.svg";
export { ForwardRef as ReactComponent };